import type { CurrenciesResponse, SingleCurrencyResponse, CurrenciesQueryParams, NetworksResponse } from "./types"
import { getApiBaseUrl } from "@/lib/api-base-url"

const fallbackCurrencies: CurrenciesResponse = {
  data: { currencies: [] },
  message: "offline_fallback",
  next: null,
  errors: null,
  meta: [],
}

const fallbackNetworks: NetworksResponse = {
  data: {
    networks: [],
    page: { current_page: 1, last_page: 1, per_page: 15, total: 0 },
  },
  message: "offline_fallback",
  next: null,
  errors: null,
  meta: [],
}

function isServerRuntime() {
  return typeof window === "undefined"
}

function getLangFromUrl(): string | undefined {
  if (typeof window === "undefined") return undefined
  const seg = window.location.pathname.split("/")[1]
  return seg === "fa" || seg === "en" ? seg : undefined
}

function buildFetchOptions(revalidateSeconds: number) {
  const lang = getLangFromUrl()
  const headers: Record<string, string> = { Accept: "application/json" }
  if (lang) headers["lang"] = lang

  if (isServerRuntime()) {
    return { headers, next: { revalidate: revalidateSeconds } }
  }
  return { headers }
}

export async function getCurrencies({
  network_id = 1,
}: CurrenciesQueryParams = {}): Promise<CurrenciesResponse> {
  const apiBaseUrl = getApiBaseUrl()
  if (!apiBaseUrl) return fallbackCurrencies
  const url = `${apiBaseUrl}/currency?network_id=${network_id}`;

  try {
    const res = await fetch(url, buildFetchOptions(60))

    if (!res.ok) {
      return fallbackCurrencies
    }

    const data = await res.json();
    return data;
  } catch {
    return fallbackCurrencies
  }
}

export async function getCurrency(symbol: string): Promise<SingleCurrencyResponse | null> {
    const apiBaseUrl = getApiBaseUrl()
    if (!apiBaseUrl) return null
    try {
      const res = await fetch(`${apiBaseUrl}/currency/${symbol}`, buildFetchOptions(60))
    if (!res.ok) {
      return null
    }
    return res.json()
    } catch {
      return null
    }
}

export async function getNetworks(): Promise<NetworksResponse> {
    const apiBaseUrl = getApiBaseUrl()
    if (!apiBaseUrl) return fallbackNetworks
    try {
      const res = await fetch(`${apiBaseUrl}/networks`, buildFetchOptions(3600))

    if (!res.ok) {
      return fallbackNetworks
    }
    return res.json()
    } catch {
      return fallbackNetworks
    }
  }
